import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/digital-learning.webp";
import extraCurriculum from "../../Images/campus/extracurriculum-cultural.webp"
import feature from "../../Images/commonimg/Picture1.webp";
import benefit from "../../Images/commonimg/Capture.webp";

const ExtraCurricular = () => {
    return (
        <>
            <title>Flexible Learning: ISBM University Digital Education Portal</title>
            <meta
                name="description"
                content="Access ISBM University's e-learning platform for remote lectures, workshops, and seminars. Bridging the gap in education through technology. Learn at your pace."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Digitized Learning System</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Digitized Learning System
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <div class="text-center mb-5">
                        <h2 class="section-title modern-title text-blue mt-3">Digitized Learning System</h2>
                        <p class="section-subtitle mx-auto fw-semibold">
                            ISBM University formally announces Digital Auditoriums on par with Digital India vision
                        </p>
                    </div>
                    <div className="vc-paragraphs mx-auto">
                        <p>
                            ISBM University, honored as the <strong>"BEST UPCOMING UNIVERSITY"</strong> by Hon. HRD Minister Shri Prakash Javdekar in association with ASSOCHAM, has taken a progressive leap by introducing <strong>Digital Auditoriums</strong> to digitize lecture relays across the University. This pioneering initiative—conceptualized, equipped, and executed entirely by ISBM—aims to modernize and streamline the delivery of academic content across its various disciplines.
                        </p>
                        <p>
                            The primary goal of this initiative is to establish a robust digital infrastructure that enables the relay of high-quality educational videos. By doing so, ISBM University seeks to reach students in far-flung and remote regions, ensuring that geography is no longer a barrier to quality education. This technology-driven approach covers diverse subject areas such as <em>Science, Arts and Humanities, Commerce and Management, Library and Information Science, Journalism, and Mass Communication</em>, all streamed from centrally located, state-of-the-art studios.
                        </p>
                        <p>
                            Through this virtual platform, the University is significantly enhancing the learning experience, especially in remote colleges where access to quality teaching can be limited. The ability to watch lectures online empowers students to feel included in the academic community, regardless of their physical location. It also ensures they can consistently engage with course material and hear directly from their tutors—bridging the gap between distance and meaningful academic connection.
                        </p>
                    </div>
                </div>
            </section>
            <section className="ptb-50">
                <div className="container-xxl">
                    <div className="text-center mb-5">
                        <h2 className="section-title modern-title text-blue mt-3">ISBM University Digitized Learning</h2>
                        <p className="section-subtitle mx-auto">Transforming education through innovative digital solutions</p>
                    </div>

                    <div className="row align-items-center g-5 mb-5">
                        <div className="col-lg-6">
                            <div className="learning-image-container">
                                <img src={feature} alt="Digitized Learning Features" className="learning-image rounded-3" />
                                <div className="digital-digital-image-overlay bg-blue"></div>
                                <div className="image-hover-content">
                                    <h4>Interactive Learning Environment</h4>
                                    <ul>
                                        <li>Live virtual classrooms</li>
                                        <li>Collaborative whiteboards</li>
                                        <li>Real-time Q&A sessions</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="learning-content">
                                <h5 className="section-title text-blue mb-4">Features of ISBM University Digitized Learning Concept:</h5>
                                <p>
                                    ISBM University is happy and proud in implementing this project with assurance that this digital lectures concept will be an asset for complete student-community. The idea is to make eminent academicians and field experts available to students with limited resources or from far-flung areas. The university already has leading academicians and it also intends to invite eminent personalities for lectures. Lecturers from various different cities like Mumbai, Hyderabad, Bangalore, Kolkata, Delhi, Chennai, etc. can deliver lectures from their own cities without having to travel to ISBM University's campus or elsewhere.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center g-5 flex-lg-row-reverse">
                        <div className="col-lg-6">
                            <div className="learning-image-container">
                                <img src={benefit} alt="Digitized Learning Benefits" className="learning-image rounded-3" />
                                <div className="digital-image-overlay bg-purple"></div>
                                <div className="image-hover-content">
                                    <h4>Student Benefits</h4>
                                    <ul>
                                        <li>Access courses 24/7</li>
                                        <li>Personalized dashboard</li>
                                        <li>Progress analytics</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="learning-content">
                                <h5 className="section-title text-blue mb-4">Benefits of ISBM University Digitized Learning Concept:</h5>
                                <p>
                                    ISBM University has showed an exemplary support to Digital India initiative and has kept up with their commitment to support digitization. ISBM University is proud to align its reform processes in tune with the national mission and vision of Hon. Prime Minister of India under the banners of Digital India, Make in India and Skills India. With this initiative as a catalyst through developing a platform which will boost educational content.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ExtraCurricular;
